/* wsapi3-adaptions-api2-to-api3 v1.0 */
/* Deploy Version 2026-10-01 14:44:05 */
/* Deploy Version 2026-09-24 19:11:07 */
/* Deploy Version 2026-07-27 16:11:01 */
/* ws-adaptions-api2-to-api3 — shims para funções legadas que dependiam da API v2 */

var _wsaLock = false;
var callbackShippingSelected = [];


// ----------------------------------------------------------------
// Ponto de entrada — chamado pelos botões da página de produto
// wsFuncBtBuy()                  → adiciona e redireciona para /carrinho
// wsFuncBtBuy('expr()')          → adiciona e executa expr após sucesso
// ----------------------------------------------------------------
function wsFuncBtBuy(funcAfterBuy) {
    _wsFuncComprar(!funcAfterBuy, funcAfterBuy);
}

// ----------------------------------------------------------------
// Ponto de entrada — chamado pelos botões de listagem/template
// wsFuncBtBuyOnList(lvID, prodId, afterFn, qty)
// ----------------------------------------------------------------
function wsFuncBtBuyOnList(lvID, productId, funcAfterBuy, qty) {
    if (_wsaLock) return;
    var quantity = Number(
        qty ||
        document.querySelector('#HD_QTD_PROD_' + productId)?.value ||
        1
    ) || 1;
    _wsFuncComprarSimples(productId, quantity, !funcAfterBuy, funcAfterBuy);
}

// ----------------------------------------------------------------
// Fluxo simplificado (listagem — sem validações de variação/kit)
// ----------------------------------------------------------------
async function _wsFuncComprarSimples(productId, quantity, goToCart, funcAfterBuy) {
    if (_wsaLock) return;
    _wsaLock = true;
    try { wsMain.tools.showLoading(); } catch (e) {}

    try {
        const result = await ApiWS.Calls.cartAddItem({ productId, quantity });
        if (result?.result === 'error_redirect' && result?.url_redirect) {
            window.location.href = result.url_redirect;
            return;
        }
        if (result?.result !== 'success') {
            _wsaErro(result?.message || 'Não foi possível incluir o produto ao carrinho.');
            return;
        }
        // Mesmo registro que _wsFuncComprar faz (ver mais abaixo) — mantém
        // window.__wsLastAddedItems consistente independente de qual fluxo rodou.
        window.__wsLastAddedItems = [{ productId, quantity }];
        _wsaSucesso(goToCart, funcAfterBuy);
    } catch (e) {
        console.error('[wsFuncBtBuyOnList]', e);
        _wsaErro('Não foi possível incluir o produto ao carrinho.');
    } finally {
        _wsaLock = false;
        try { setTimeout(() => wsMain.tools.hideLoading(), 500); } catch (e) {}
    }
}

// ----------------------------------------------------------------
// Fluxo completo (página de produto — com todas as validações)
// ----------------------------------------------------------------
async function _wsFuncComprar(goToCart, funcAfterBuy) {
    if (_wsaLock) return;

    // 1. Variações de kit
    const kitVariations = [];
    let kitProblems = false;
    try {
        document.querySelectorAll('select.kit__combo').forEach(function (sel) {
            if (kitProblems) return;
            if (!sel.value) {
                _wsaErro('Selecione a variação de todos produtos do kit.');
                sel.focus();
                kitProblems = true;
                return;
            }
            kitVariations.push({ prod: sel.id.replace('kit_variation_', ''), var: sel.value });
        });
    } catch (e) {}
    if (kitProblems) return;

    // 2. Tabela de sub-produtos (combo/multi-item)
    const subProdsTable = document.querySelector('#LV_TABLE_SUBPRODUTOS');
    const subProdsList = [];
    if (subProdsTable) {
        subProdsTable.querySelectorAll('select').forEach(function (sel) {
            const prodId = sel.getAttribute('rel');
            const qty = Number(document.querySelector('#LV_SELECT_PROD_TRABLE_' + prodId)?.value || 0);
            if (qty > 0) subProdsList.push({ productId: prodId, quantity: qty });
        });
        if (!subProdsList.length) {
            _wsaErro('Selecione a quantidade do produto que deseja comprar.');
            subProdsTable.querySelector('select')?.focus();
            return;
        }
    }

    // 3. Variação principal (gênero)
    const generoEl = document.querySelector('#LV_PROD_GENERO');
    if (generoEl !== null && generoEl.value === '') {
        const nomeGenero = document.querySelector('#LV_HD_GENERO_NOME')?.value || 'variação';
        _wsaErro('Selecione a variação ' + nomeGenero + '.');
        generoEl.focus();
        return;
    }
    const genero2 = document.querySelector('#LV_HD_GENERO_2')?.value || '0';
    const genero3 = document.querySelector('#LV_HD_GENERO_3')?.value || '0';
    // Aceita tanto o campo legado (#LV_HD_GENERO_SELECT_N) quanto o select gerado pela api3 (#LV_PROD_GENERO_N)
    if (genero2 !== '0' && genero2 &&
        !document.querySelector('#LV_HD_GENERO_SELECT_2')?.value &&
        !document.querySelector('#LV_PROD_GENERO_2')?.value) {
        _wsaErro('Selecione a variação ' + (document.querySelector('#LV_HD_GENERO_NOME_2')?.value || '') + '.');
        return;
    }
    if (genero3 !== '0' && genero3 &&
        !document.querySelector('#LV_HD_GENERO_SELECT_3')?.value &&
        !document.querySelector('#LV_PROD_GENERO_3')?.value) {
        _wsaErro('Selecione a variação ' + (document.querySelector('#LV_HD_GENERO_NOME_3')?.value || '') + '.');
        return;
    }

    // 4. Campos adicionais obrigatórios
    const camposAddEl = document.querySelector('#LV_HD_CAMPOS_ADD');
    const hasApiV3AddFields = !!document.querySelector('.LVCamposAddTexto[data-campo-id]');
    if (camposAddEl?.value || hasApiV3AddFields) {
        let camposOk = true;
        document.querySelectorAll('.LVCamposAddTexto').forEach(function (input) {
            if (!camposOk) return;
            const name = input.getAttribute('name');
            const val = input.value;
            if (!val || !val.trim()) {
                _wsaErro('Preencha o campo: ' + name);
                try { input.focus(); } catch (_) {}
                camposOk = false;
                return;
            }
            if (input.tagName !== 'SELECT' && (val.includes('|') || val.includes('§'))) {
                _wsaErro('O campo ' + name + ' não permite os caracteres | e §');
                try { input.focus(); } catch (_) {}
                camposOk = false;
                return;
            }
            const maxLen = Number(input.getAttribute('maxlength') || input.getAttribute('limit') || 0);
            if (maxLen && val.trim().length > maxLen) {
                _wsaErro('O campo ' + name + ' deve ter no máximo ' + maxLen + ' caracteres');
                camposOk = false;
            }
        });
        if (!camposOk) return;
    }

    // 4b. Coleta campos adicionais api3 para envio no carrinho
    const additionalFields = [];
    document.querySelectorAll('.LVCamposAddTexto[data-campo-id]').forEach(function (input) {
        const fieldId = parseInt(input.getAttribute('data-campo-id'), 10);
        const title = input.getAttribute('name') || '';
        const value = (input.value || '').trim();
        if (!isNaN(fieldId) && value) {
            additionalFields.push({ field_id: fieldId, title, value });
        }
    });

    // 5. Produto e quantidade
    const prodIdEl = document.querySelector('#LV_HD_PROD_ID');
    if (!prodIdEl?.value) return;

    let productId = prodIdEl.value;

    // Se há variação selecionada, resolve o ID da variação correta.
    // Para produtos multi-dimensão faz intersecção pelos valores de atributo;
    // para single-dim usa diretamente o valor do select (que já é o ID da variação).
    if (generoEl && generoEl.value) {
        try {
            const variacoes = wsMain.globalData.infoProduto?.variacoes;
            if (Array.isArray(variacoes) && variacoes.length > 0) {
                const selectedTexts = [];
                for (let dim = 1; dim <= 3; dim++) {
                    const suffix = dim === 1 ? '' : '_' + dim;
                    const sel = document.querySelector('#LV_PROD_GENERO' + suffix);
                    if (!sel || !sel.value) break;
                    selectedTexts.push(sel.options[sel.selectedIndex]?.text || '');
                }
                const matched = variacoes.find(v =>
                    Array.isArray(v.atributos) &&
                    v.atributos.length >= selectedTexts.length &&
                    selectedTexts.every((txt, i) => v.atributos[i]?.valor === txt)
                );
                productId = matched ? String(matched.id) : generoEl.value;
            } else {
                productId = generoEl.value;
            }
        } catch (_) {
            productId = generoEl.value;
        }
    }

    const quantity = Math.max(1, Number(document.querySelector('#TxtQtdAdd')?.value || 1) || 1);

    // 6. Campos personalizados (variation_values)
    let variationValues = [];
    try {
        const raw = document.querySelector('#HD_JsonValoresAdicionais')?.value || '';
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed?.valores) && parsed.valores.length) variationValues = parsed.valores;
        }
    } catch (e) {}

    // 7. Verificação de estoque (best-effort via dados já carregados)
    try {
        const infoProd = wsMain.globalData.infoProduto;
        if (infoProd) {
            const estoqueVar = infoProd.variacoes?.find(v => String(v.id) === String(productId));
            const estoque = estoqueVar ? estoqueVar.estoque : (infoProd.qtd_disponivel || Infinity);
            if (quantity > estoque) {
                _wsaErro('A quantidade (' + quantity + ') desejada não está disponível. Estoque máximo: ' + estoque);
                return;
            }
        }
    } catch (e) {}

    // 8. Executar chamada
    _wsaLock = true;
    const btComprar = document.querySelector('#LV_BT_COMPRAR');
    if (btComprar) btComprar.style.display = 'none';
    try { wsMain.tools.showLoading(); } catch (e) {}

    try {
        const items = subProdsList.length ? subProdsList : [{ productId, quantity }];
        let lastResult;
        for (const item of items) {
            lastResult = await ApiWS.Calls.cartAddItem({
                productId: item.productId,
                quantity: item.quantity,
                variationValues,
                kitVariations,
                additionalFields
            });
            if (lastResult?.result !== 'success') {
                // error_redirect / PRODUCT_REQUIRES_SELECTION = componente de kit com grade
                // sem variação escolhida (ou var inválida). A API mandaria redirecionar pra
                // PDP — mas já estamos nela: só avisa e mantém o usuário aqui.
                if (lastResult?.result === 'error_redirect' || lastResult?.error_code === 'PRODUCT_REQUIRES_SELECTION') {
                    _wsaErro(lastResult?.message || 'Selecione a variação de todos os produtos do kit.');
                } else {
                    _wsaErro(lastResult?.message || 'Não foi possível incluir o produto ao carrinho.');
                }
                if (btComprar) btComprar.style.display = '';
                return;
            }
        }
        // Guarda os itens que ACABARAM de entrar (1 ou vários — ex.: várias linhas da
        // tabela de sub-produtos/#LV_TABLE_SUBPRODUTOS, cada uma com sua própria
        // quantidade) pra quem monta a sidebar de confirmação (funcAfterBuy, avaliado
        // a seguir) saber o que exibir de verdade, em vez de assumir sempre "1 item,
        // o produto base". Lido por wsMain.modules['pag-produto'].openAddedToCartSidebar
        // (wsapi3-pag-prod-rules.js) antes de eval(funcAfterBuy) rodar — sempre fresco,
        // sem risco de ficar velho, já que é setado bem aqui, na mesma execução síncrona.
        window.__wsLastAddedItems = items;
        _wsaSucesso(goToCart, funcAfterBuy);
    } catch (e) {
        console.error('[wsFuncBtBuy]', e);
        _wsaErro('Não foi possível incluir o produto ao carrinho.');
        if (btComprar) btComprar.style.display = '';
    } finally {
        _wsaLock = false;
        try { setTimeout(() => wsMain.tools.hideLoading(), 500); } catch (e) {}
    }
}

// ----------------------------------------------------------------
// Helpers internos
// ----------------------------------------------------------------
function _wsaSucesso(goToCart, funcAfterBuy) {
    if (goToCart) {
        window.location.href = '/carrinho';
    } else if (funcAfterBuy) {
        try { eval(funcAfterBuy); } catch (e) { console.error('[wsFuncBtBuy] funcAfterBuy', e); }
    }
}

function _wsaErro(msg) {
    if (typeof wsMain !== 'undefined' && typeof wsMain.showAlert === 'function') { wsMain.showAlert(msg, 'Atenção'); return; }
    if (typeof AlertaErro === 'function') { AlertaErro(msg); return; }
    alert(msg);
}

// ----------------------------------------------------------------
// Shims de carrinho — substituem as funções legadas que conversavam
// com o backend antigo. Após cada operação, buscam /cart/view e
// atualizam cartJson, o que aciona o watcher de lastUpdate do
// ws-checkout-cart e força o re-render automático.
// ----------------------------------------------------------------
async function productQtdChange(itemId, qty) {
    try {
        const result = await ApiWS.Calls.cartItemUpdate({ itemId, quantity: qty });
        if (result?.result !== 'success') return;
        await _wsaRefreshCartJson();
    } catch (e) {
        console.error('[productQtdChange]', e);
    }
}

async function removeProductCart(itemId, groupId) {
    try {
        const result = await ApiWS.Calls.cartItemRemove({ itemId, groupId: groupId || '' });
        if (result?.result !== 'success') return;
        await _wsaRefreshCartJson();
    } catch (e) {
        console.error('[removeProductCart]', e);
    }
}

async function _wsaRefreshCartJson() {
    const fresh = await ApiWS.Calls.cartView();
    if (!fresh || typeof cartJson === 'undefined') return;
    Object.assign(cartJson, fresh);
}

// ----------------------------------------------------------------
// Substituição de imagens quebradas por 1×1 px transparente
// ----------------------------------------------------------------
(function () {
    var BLANK = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';

    document.addEventListener('error', function (e) {
        var el = e.target;
        if (el.tagName === 'IMG' && el.src !== BLANK) {
            el.src = BLANK;
        }
    }, true);
}());
